import { render, staticRenderFns } from "./integrations-power-dialer-api.vue?vue&type=template&id=ceb7b986"
import script from "./integrations-power-dialer-api.vue?vue&type=script&lang=js"
export * from "./integrations-power-dialer-api.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports